export const maskOnlyNumbers = (
  value: string | number | null | undefined
): string => {
  if (value === null || value === undefined) {
    return ''
  }

  return value.toString().replace(/\D/g, '')
}

export const maskDate = (value: string) => {
  const newValue = maskOnlyNumbers(value)

  return newValue
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

export const maskPhone = (value: string) => {
  const newValue = maskOnlyNumbers(value)
  const sizeValue = newValue.length

  if (sizeValue < 3) {
    return newValue.replace(/(\d{1,2})/g, '($1')
  } else if (sizeValue < 8) {
    return newValue.replace(/(\d{2})(\d{1,5})/g, '($1) $2')
  }

  return newValue.replace(/(\d{2})(\d{5})(\d{1,4})/g, '($1) $2-$3')
}

export const maskCPF = (value: string) => {
  const newValue = maskOnlyNumbers(value)

  return newValue
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}
